import * as React from "react";
import { CoopConstants } from "../../../constants/CoopConstants";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilTime } from "../../../utils/utilTime";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { IconWithProgress } from "../../generic/icon-with-progress/IconWithProgress";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TextLoca } from "../../generic/text/TextLoca";
import { TimerCountdown } from "../../generic/timer/TimerCountdown";
export var CoopSendPoints = function (_a) {
    var cooldownEndTime = _a.cooldownEndTime, onSendCoopPoints = _a.onSendCoopPoints, coopId = _a.coopId, playerId = _a.playerId;
    var secondsLeft = cooldownEndTime ? utilTime.secondsLeftTill(cooldownEndTime) : 0;
    var progress = utilTime.timerProgressReversed(secondsLeft, CoopConstants.CoolDownTime);
    return cooldownEndTime ? (React.createElement("div", { className: "flex flex--stacked flex--guts flex--spaced flex--around" },
        React.createElement(TextLoca, { className: IdStyles.TextSmall, id: IdLoca.coopHelp_loyaltypointCooldown }),
        React.createElement(IconWithProgress, { progressPercent: progress, icon: IdIcon.ConstructionTimeIcn, iconStyle: IdStyles.IconMedium, fillClassName: IdStyles.ProgressBarFill, backgroundClassName: IdStyles.ProgressBarBackground },
            React.createElement(TimerCountdown, { remainingTime: cooldownEndTime, className: IdStyles.TextNormal })))) : (React.createElement(ButtonPrimary, { onClick: function () { return onSendCoopPoints(playerId, coopId); } },
        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.send })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/help/CoopSendPoints.tsx
// module id = 2605
// module chunks = 3